/*
  Best Engravings: engraving proof tick in the bag drawer (mockup 3a moved it here from checkout,
  which the theme cannot change). Markup: snippets/cart-drawer.liquid (.be-proof, only when the
  bag has engraved items and the Cart drawer section's "Ask shoppers to confirm..." is on).

  - Until the box is ticked, #CartDrawer-Checkout reads LOCKED_LABEL and a click (or any submit of
    #CartDrawer-Form) only points the shopper at the box. Express checkout buttons are dimmed and
    do the same.
  - Ticking enables the hidden input attributes[Engraving proof]=Confirmed, which goes to the order
    with the Checkout submit.
  - The tick is remembered for this tab (sessionStorage) against data-be-proof-sig, the list of
    engraved line keys. Changing an engraving changes its key, so it has to be confirmed again;
    quantity changes do not.
  - The drawer markup is replaced on every cart update, so listeners are delegated from document
    and a MutationObserver re-applies the state to fresh markup.
*/
(function () {
  if (window.BECartProof) return;

  var KEY = 'be-proof-sig';
  var LOCKED_LABEL = 'Confirm your engraving to check out';
  var NUDGE_TEXT = 'Tick the box to confirm your engraving is right.';

  var confirmed = load();

  function load() {
    try {
      return window.sessionStorage.getItem(KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function save(value) {
    try {
      if (value) window.sessionStorage.setItem(KEY, value);
      else window.sessionStorage.removeItem(KEY);
    } catch (e) {
      /* private mode: remembered for this page view only */
    }
  }

  function proofBox() {
    return document.querySelector('cart-drawer [data-be-proof]');
  }

  function isLocked() {
    var box = proofBox();
    return !!box && box.getAttribute('data-be-proof-sig') !== confirmed;
  }

  function setMessage(box, text) {
    var msg = box && box.querySelector('[data-be-proof-msg]');
    if (msg && msg.textContent !== text) msg.textContent = text;
  }

  function paint() {
    var locked = isLocked();
    var box = proofBox();
    if (box) {
      var check = box.querySelector('[data-be-proof-check]');
      var attr = box.querySelector('[data-be-proof-attr]');
      if (check && check.checked === locked) check.checked = !locked;
      if (attr) attr.disabled = locked;
      box.classList.toggle('is-confirmed', !locked);
      if (!locked) {
        box.classList.remove('is-nudged');
        setMessage(box, '');
      }
    }

    var btn = document.getElementById('CartDrawer-Checkout');
    if (btn) {
      if (!btn.hasAttribute('data-be-label')) btn.setAttribute('data-be-label', btn.textContent.trim());
      var label = locked ? LOCKED_LABEL : btn.getAttribute('data-be-label');
      if (btn.textContent.trim() !== label) btn.textContent = label;
      btn.classList.toggle('is-locked', locked);
    }

    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (inner) inner.classList.toggle('be-proof-locked', locked);
  }

  function nudge() {
    var box = proofBox();
    if (!box) return;
    box.classList.add('is-nudged');
    setMessage(box, NUDGE_TEXT);
    var check = box.querySelector('[data-be-proof-check]');
    if (check) check.focus();
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('[data-be-proof-check]')) return;
    var box = target.closest('[data-be-proof]');
    if (!box) return;
    confirmed = target.checked ? box.getAttribute('data-be-proof-sig') : '';
    save(confirmed);
    paint();
  });

  // Capture phase: runs before Dawn's handlers and before the form submits.
  document.addEventListener(
    'click',
    function (event) {
      var t = event.target;
      if (!t || !t.closest || !isLocked()) return;
      if (t.closest('#CartDrawer-Checkout') || t.closest('cart-drawer .cart__dynamic-checkout-buttons')) {
        event.preventDefault();
        event.stopPropagation();
        nudge();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      if (!event.target || event.target.id !== 'CartDrawer-Form' || !isLocked()) return;
      event.preventDefault();
      event.stopPropagation();
      nudge();
    },
    true
  );

  function observe() {
    paint();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(paint).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();

  window.BECartProof = { isLocked: isLocked, paint: paint };
})();
